import { render } from "./MessageThread.vue?vue&type=template&id=0b46e0eb&scoped=true"
import script from "./MessageThread.vue?vue&type=script&lang=js"
export * from "./MessageThread.vue?vue&type=script&lang=js"

import "./MessageThread.vue?vue&type=style&index=0&id=0b46e0eb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b46e0eb"]])

export default __exports__